import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Styled from '../../../../lab/Styled';
import Picker from './CustomPicker';

var ColorPicker =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ColorPicker, _React$PureComponent);

  function ColorPicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ColorPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChange = function (color) {
      if (_this.props.disableAlpha) {
        color.hsl.a = 1;
        color.hsv.a = 1;
        color.rgb.a = 1;
      }

      _this.props.onChange(color);
    };

    return _this;
  }

  _createClass(ColorPicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          disableAlpha = _this$props.disableAlpha;
      return React.createElement(Styled, {
        styles: styles,
        name: "ECColorPicker"
      }, function (classes) {
        return React.createElement("div", {
          "data-testid": "color-picker"
        }, React.createElement(Picker, {
          disableAlpha: disableAlpha,
          color: value,
          onChangeComplete: _this2.onChange,
          className: classes.picker
        }));
      });
    }
  }]);

  return ColorPicker;
}(React.PureComponent);

var styles = function styles() {
  return {
    picker: {
      minWidth: 100
    }
  };
};

ColorPicker.defaultProps = {
  disableAlpha: true
};
export default ColorPicker;